import allApi from '../../api'
import type { AutoWorksheet, AutoWorksheetDecisionDTO, AutoWorksheetRevision, VehicleEvaluationDTO } from '../../types'
import { makeGetById, makeGetListWithIds, makeSave } from '../effects/standard-side-effects'
import {
  AutoworksheetSlice,
  GET_AUTO_WORKSHEET_BY_ID,
  GET_AUTO_WORKSHEET_REVISIONS,
  SAVE_AUTO_WORKSHEET,
  SAVE_DECISION,
  SAVE_VEHICLE_INTERNAL_EVALUATION,
} from './auto-worksheet-store'

const worksheetEffects = {
  getById: (id: string) =>
    makeGetById<AutoWorksheet>(
      GET_AUTO_WORKSHEET_BY_ID,
      allApi.worksheet.getById,
      AutoworksheetSlice.actions.setCurrent,
      {
        id,
      },
    ),
  create: (creditApplicationId: string) =>
    makeSave<AutoWorksheet>(SAVE_AUTO_WORKSHEET, allApi.worksheet.create, AutoworksheetSlice.actions.setCurrent, {
      creditApplicationId,
    }),
  update: (data: Partial<AutoWorksheet>) =>
    makeSave<AutoWorksheet>(SAVE_AUTO_WORKSHEET, allApi.worksheet.update, AutoworksheetSlice.actions.setCurrent, data),
  updateVehicleEvaluationDTO: (data: VehicleEvaluationDTO) =>
    makeSave<VehicleEvaluationDTO, AutoWorksheet>(
      SAVE_VEHICLE_INTERNAL_EVALUATION,
      allApi.worksheet.updateVehicleEvaluationDTO,
      AutoworksheetSlice.actions.setCurrent,
      data,
    ),
  updateDecision: (data: AutoWorksheetDecisionDTO) =>
    makeSave<AutoWorksheetDecisionDTO, AutoWorksheet>(
      SAVE_DECISION,
      allApi.worksheet.updateDecision,
      AutoworksheetSlice.actions.setCurrent,
      data,
    ),
  getWorksheetRevisions: (id: string) =>
    makeGetListWithIds<AutoWorksheetRevision>(
      GET_AUTO_WORKSHEET_REVISIONS,
      allApi.worksheet.getWorksheetRevisions,
      AutoworksheetSlice.actions.setCurrentRevisions,
      { creditApplicationId: id },
    ),
}

export default worksheetEffects
